import { bearerAuth, oauthAuth, dcrOAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

export const resend = defineProduct({
  name: "Resend",
  tagLine: "Email API for developers",
  keywords:
    "transactional smtp deliverability domains broadcasts audiences contacts",
  logo,
  tags: ["communication"],
  variants: [
    productVariant({
      identifier: "resend",
      authLabel: "API key",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.resend\\.com/.*",
      auth: (app) => bearerAuth(app.secret.apiKey),
      steps: [
        {
          title: "Create an API key",
          items: [
            {
              kind: "markdown",
              content:
                "Log in to the [Resend dashboard](https://resend.com/api-keys) and click **Create API Key**.\n\nGive it a name, select the appropriate permission level and domain, then click **Add**.",
            },
          ],
        },
        {
          title: "Enter your API key",
          items: [
            {
              kind: "markdown",
              content:
                "Paste the API key you just created. **Make sure to copy it now** — Resend only shows it once.",
            },
            {
              kind: "input",
              label: "API key",
              placeholder: "re_...",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://api.resend.com/domains",
      },
    }),

    productVariant({
      identifier: "resendOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.resend\\.com/.*",
      auth: () => oauthAuth,
      oauth: dcrOAuth({
        serverUrl: "https://api.resend.com",
        issuer: "https://api.resend.com",
        authorizationEndpoint: "https://api.resend.com/oauth/authorize",
        tokenEndpoint: "https://api.resend.com/oauth/token",
        scopes: ["full_access"],
      }),
      steps: [
        {
          title: "Connect to Resend",
          items: [
            {
              kind: "markdown",
              content:
                "Sign in to Resend and approve access to your team. This connection requests full_access so workflows can manage domains, contacts, and email as well as send messages. You can revoke access in Resend’s team settings.",
            },
            { kind: "oauth" },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://api.resend.com/domains",
      },
    }),
  ],
});
